import { ORDER_TYPE } from "util/constants";

const INITIAL_STATE = {
  basket: [],
  note: "",
  request: "",
  orderAddress: {},
  orderType: ORDER_TYPE.DELIVERY,
  payment: null,
  surcharges: [],
  taxes: [],
  discount: null,
  transaction: null,
};

export default INITIAL_STATE;
